export const filterButtons = [
  {
    text: "challenges.badges.new",
    value: "discover-new",
  },
  // {
  //   text: "challenges.badges.mine",
  //   value: "mine",
  // },
  // {
  //   text: "challenges.badges.zone",
  //   value: "zone-activity",
  // },
];
